module.exports = __webpack_public_path__ + "static/img/ico_building_arrowmoney.c793236.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ico_building_arrowmoney.png
// module id = dOMS
// module chunks = 1